import { useTranslation } from 'react-i18next';

export const useTranslate = () => {
    const { t, i18n } = useTranslation();

    return {
        t,
        i18n,
        changeLanguage: i18n.changeLanguage,
        currentLanguage: i18n.language,
    };
};
